import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class GrupoKeys extends MainKeys {
    get place() {
        return Places.grupo
    }
}

export default GrupoKeys
